import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/apps/junonkuji/src/app/error.tsx");
